import { z } from "zod";

import { JavaCurrencyValue } from "../../../utils/currency";

const JavaCurrencyValueSchema: z.ZodType<JavaCurrencyValue> = z.object({
  currency: z.string(),
  amount: z.string(),
  decimalPoints: z.string(),
  displayAmount: z.string(),
});

const RouteEntrySchema = z.object({
  route: z.string(),
  city: z.string(),
  amount: JavaCurrencyValueSchema,
});

const Top5FlightRoutesTransactionEntrySchema = z.object({
  truncatedDate: z.string().optional(),
  quarter: z.string(),
  month: z.string(),
  year: z.string(),
  routes: z.array(RouteEntrySchema),
});

export const Top5FlightRoutesTransactionsResultSchema = z.object({
  top5FlightRoutesTransactions: z.object({
    transactions: z.array(Top5FlightRoutesTransactionEntrySchema),
  }),
});

export type Top5FlightRoutesTransactionsResult = z.infer<
  typeof Top5FlightRoutesTransactionsResultSchema
>;
